import { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import DatePicker from 'react-datepicker'

const AnswerTimePicker = ({ answer, question, onInputChange }) => {
  const { t } = useTranslation(['booking'])
  const [date, setDate] = useState(null)

  const handleChange = (date) => {
    setDate(date)
    onInputChange(question, answer, date)
  }

  return (
    <div className="date-picker-wrapp-container">
      <DatePicker
        key={answer.customId}
        selected={date || null}
        onChange={(date) => handleChange(date)}
        placeholderText={t('booking:timePicker.placeholder')}
        showTimeSelect
        timeIntervals={15}
        dateFormat="P h:mm a"
      />
    </div>
  )
}

AnswerTimePicker.propTypes = {
  answer: PropTypes.object,
  question: PropTypes.object,
  onInputChange: PropTypes.func,
}

export default AnswerTimePicker
